
import React from 'react';
import Slider from './Slider';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaGraduationCap, FaChalkboardTeacher, FaSchool, FaHome, FaUser } from 'react-icons/fa';


import Navbar from './Header';
import Footer from './Footer';

const Homepage = () => {


  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
const styles = {

  // Features Section - New Design
  featuresSection: {
    padding: '100px 0',
    backgroundColor: '#ffffff',
    position: 'relative',
  },

  sectionContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
    position: 'relative',
  },

  sectionHeading: {
    textAlign: 'center',
    marginBottom: '70px',
  },

  sectionTitle: {
    fontSize: '2.8rem',
    fontWeight: '800',
    color: '#0f172a',
    marginBottom: '20px',
    fontFamily: "'Montserrat', sans-serif",
    position: 'relative',
    display: 'inline-block',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-10px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '80px',
      height: '4px',
      background: 'linear-gradient(90deg, #4cc9f0, #f72585)',
      borderRadius: '2px',
    }
  },

  sectionSubtitle: {
    fontSize: '1.2rem',
    color: '#64748b',
    maxWidth: '700px',
    margin: '0 auto',
    lineHeight: '1.7',
    fontFamily: "'Poppins', sans-serif",
  },

  featuresGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: '40px',
    marginTop: '60px',
  },

  featureCard: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    padding: '50px 35px',
    boxShadow: '0 5px 30px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.4s ease',
    textAlign: 'center',
    border: '1px solid rgba(0,0,0,0.03)',
    '&:hover': {
      transform: 'translateY(-10px)',
      boxShadow: '0 15px 40px rgba(0, 0, 0, 0.1)',
      borderColor: 'rgba(76, 201, 240, 0.2)',
    },
  },

  featureIcon: {
    fontSize: '2.8rem',
    marginBottom: '30px',
    color: '#ffffff',
    background: 'linear-gradient(135deg, #4cc9f0 0%, #f72585 100%)',
    width: '90px',
    height: '90px',
    borderRadius: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 30px',
    boxShadow: '0 10px 20px rgba(76, 201, 240, 0.3)',
  },

  featureTitle: {
    fontSize: '1.6rem',
    fontWeight: '700',
    marginBottom: '20px',
    color: '#0f172a',
    fontFamily: "'Poppins', sans-serif",
  },

  featureText: {
    fontSize: '1.1rem',
    color: '#64748b',
    lineHeight: '1.8',
    fontFamily: "'Poppins', sans-serif",
  },


    container: {
      width: '100%',
      overflow: 'hidden',
      position: 'relative',
    },
    slide: {
      position: 'relative',
      textAlign: 'left',
      color: '#fff',
    },
    image: {
      width: '100%',
      height: '90vh',
      objectFit: 'cover',
      filter: 'brightness(0.7)',
      transition: 'transform 0.5s ease, filter 0.5s ease',
      ':hover': {
        transform: 'scale(1.02)',
        filter: 'brightness(0.8)',
      },
    },
    overlay: {
      position: 'absolute',
      top: '30%',
      left: '10%',
      backgroundColor: 'rgba(0,0,0,0.4)',
      backdropFilter: 'blur(5px)',
      padding: '40px',
      borderRadius: '15px',
      maxWidth: '650px',
      borderLeft: '4px solid #FF4D4D',
      transform: 'translateY(20px)',
      opacity: 0,
      animation: 'fadeInUp 0.8s ease forwards',
    },
    title: {
      fontSize: '3.5rem',
      fontWeight: '800',
      marginBottom: '20px',
      fontFamily: "'Montserrat', sans-serif",
      lineHeight: '1.2',
      textShadow: '2px 2px 8px rgba(0,0,0,0.5)',
      background: 'linear-gradient(45deg, #FF4D4D, #F9CB28)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      animation: 'gradientShift 8s ease infinite',
    },
    subtitle: {
      fontSize: '1.3rem',
      marginBottom: '30px',
      fontWeight: '300',
      lineHeight: '1.6',
      color: 'rgba(255,255,255,0.9)',
    },
    buttons: {
      display: 'flex',
      gap: '20px',
    },
    btn: {
      padding: '15px 32px',
      fontSize: '1.1rem',
      borderRadius: '50px',
      cursor: 'pointer',
      transition: 'all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)',
      fontWeight: '600',
      letterSpacing: '0.5px',
      textTransform: 'uppercase',
      boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
      ':hover': {
        transform: 'translateY(-3px)',
        boxShadow: '0 8px 20px rgba(0,0,0,0.3)',
      },
      ':active': {
        transform: 'translateY(0)',
      },
    },
    primaryBtn: {
      background: 'linear-gradient(45deg, #FF416C, #FF4D4D)',
      color: '#fff',
      border: 'none',
      ':hover': {
        background: 'linear-gradient(45deg, #FF4D4D, #FF416C)',
      },
    },
    secondaryBtn: {
      background: 'transparent',
      color: '#fff',
      border: '2px solid #fff',
      ':hover': {
        background: 'rgba(255,255,255,0.1)',
        borderColor: 'transparent',
      },
    },
    // Keyframes for animations (to be added to your global CSS)
    '@keyframes fadeInUp': {
      from: {
        opacity: 0,
        transform: 'translateY(20px)',
      },
      to: {
        opacity: 1,
        transform: 'translateY(0)',
      },
    },
    '@keyframes gradientShift': {
      '0%': { backgroundPosition: '0% 50%' },
      '50%': { backgroundPosition: '100% 50%' },
      '100%': { backgroundPosition: '0% 50%' },
    },
  };

  return (
    <>
    <Navbar/>
   <Slider/>


      <section style={styles.featuresSection}>
        <div style={styles.sectionContainer}>
          <div style={styles.sectionHeading}>
            <h2 style={styles.sectionTitle}>Why Choose Vidyabhushan Minority Educational Institute?</h2>
            <p style={styles.sectionSubtitle}>
              We provide an environment that nurtures intellectual curiosity, creativity, 
              and personal growth while instilling strong moral values.
            </p>
          </div>
          
          <div style={styles.featuresGrid}>
            <div style={styles.featureCard}>
              <div style={styles.featureIcon}><FaGraduationCap /></div>
              <h3 style={styles.featureTitle}>Quality Education</h3>
              <p style={styles.featureText}>
                Our experienced faculty delivers comprehensive education with modern 
                teaching methodologies and personalized attention.
              </p>
            </div>
            
            <div style={styles.featureCard}>
              <div style={styles.featureIcon}><FaChalkboardTeacher /></div>
              <h3 style={styles.featureTitle}>Experienced Faculty</h3>
              <p style={styles.featureText}>
                Highly qualified and dedicated teachers who are passionate about 
                shaping young minds and fostering academic excellence.
              </p>
            </div>
            
            <div style={styles.featureCard}>
              <div style={styles.featureIcon}><FaSchool /></div>
              <h3 style={styles.featureTitle}>Modern Facilities</h3>
              <p style={styles.featureText}>
                Well-equipped classrooms, science labs, computer labs, and a 
                comprehensive library to support all-round development.
              </p>
            </div>
          </div>
        </div>
      </section>

    

      <Footer />
    </>
  );
};

export default Homepage;











